/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
import { fbConfig, fbConfigStaging } from '../firebaseConfig';
import { getFirestore, updateDoc, getDoc, doc, onSnapshot, getDocs, collection } from 'firebase/firestore';
import { getAuth, setPersistence, onAuthStateChanged, browserLocalPersistence } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_OFFLINE = 'UPDATE_OFFLINE';
export const UPDATE_DRAWER_STATE = 'UPDATE_DRAWER_STATE';
export const OPEN_SNACKBAR = 'OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const FIREBASE_INITIALIZE = 'FIREBASE_INITIALIZE';
export const FIREBASE_AUTH_INITIALIZE = 'FIREBASE_AUTH_INITIALIZE';
export const FIREBASE_AUTHORIZE = 'FIREBASE_AUTHORIZE';
export const FIREBASE_SIGNOUT = 'FIREBASE_SIGNOUT';
export const FIREBASE_FIRESTORE = 'FIREBASE_FIRESTORE';
export const COMPANY_LOADED = 'COMPANY_LOADED';
export const VENDOR_LOADED = 'VENDOR_LOADED';
export const PERSON_LOADED = 'PERSON_LOADED';
export const LOAD_ORGANIZATIONS = 'LOAD_ORGANIZATIONS';
export const ORGANIZATIONS_LOADED = 'ORGANIZATIONS_LOADED';
export const LOAD_JOBS = 'LOAD_JOBS';
export const JOBS_LOADED = 'JOBS_LOADED';
export const JOB_GET = 'JOB_GET';
export const LOAD_JOBTYPES = 'LOAD_JOBTYPES';
export const JOBTYPES_LOADED = 'JOBTYPES_LOADED';
export const LOAD_BACKGROUNDSETS = 'LOAD_BACKGROUNDSETS';
export const BACKGROUNDSETS_LOADED = 'BACKGROUNDSETS_LOADED';
export const LOAD_BACKGROUNDS = 'LOAD_BACKGROUNDS';
export const BACKGROUNDS_LOADED = 'BACKGROUNDS_LOADED';
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export const navigate = (path) => (dispatch) => {
    // Extract the page name from path. Remove Querystring
    const page = path === '/' ? 'home' : path.slice(1).split("#")[0].split("?")[0];
    dispatch(loadPage(page));
    window.history.pushState({}, '', path);
    // Close the drawer - in case the *path* change came from a link in the drawer.
    dispatch(updateDrawerState(false));
};
const loadPage = (page) => (dispatch) => {
    switch (page.split("#")[0].split("/")[0]) {
        case 'login':
            import('../components/templates/my-login.js').then((_module) => {
                // Put code in here that you want to run every time when
                // navigating to view1 after my-view1.js is loaded.
                dispatch(updatePage(page));
            });
            break;
        case 'home':
            import('../components/my-home.js');
            break;
        case 'capture':
            import('../components/my-capture.js');
            break;
        case 'jobs':
            import('../components/my-jobs.js').then((_module) => {
            });
            break;
        case 'organizations':
            import('../components/my-organizations.js').then((_module) => {
            });
            break;
        case 'company':
            import('../components/my-company.js');
            break;
        case 'production':
            import('../components/my-production.js');
            break;
        case 'orders':
            import('../components/my-orders.js');
            break;
        case 'customerservice':
            import('../components/my-customerservice.js');
            break;
        case 'job':
            import('../components/my-job.js');
            break;
        case 'accounting':
            import('../components/my-accounting.js');
            break;
        case 'layouts':
            import('../components/my-layouts.js');
            break;
        case 'lab':
            import('../components/my-lab.js');
            break;
        case 'sales':
            import('../components/my-sales.js');
            break;
        case 'photography':
            import('../components/my-photography.js');
            break;
        case 'vendor':
            import('../components/vendor/vendor-vendor.js');
            break;
        case 'vendorjobs':
            import('../components/vendor/vendor-jobs.js');
            break;
        case 'oauth':
            console.log(page);
            break;
        default:
            page = 'view404';
            import('../components/my-view404.js');
    }
    if (page != 'login')
        dispatch(updatePage(page));
};
const updatePage = (page) => {
    return {
        type: UPDATE_PAGE,
        page
    };
};
let snackbarTimer;
export const showSnackbar = () => (dispatch) => {
    dispatch({
        type: OPEN_SNACKBAR
    });
    window.clearTimeout(snackbarTimer);
    snackbarTimer = window.setTimeout(() => dispatch({ type: CLOSE_SNACKBAR }), 3000);
};
export const updateOffline = (offline) => (dispatch, getState) => {
    // Show the snackbar only if offline status changes.
    if (offline !== getState().app.offline) {
        dispatch(showSnackbar());
    }
    dispatch({
        type: UPDATE_OFFLINE,
        offline
    });
};
export const updateDrawerState = (opened) => {
    return {
        type: UPDATE_DRAWER_STATE,
        opened
    };
};
export const firebaseInitialize = () => (dispatch) => {
    var fb = initializeApp(["staging.bluewatersuite.net", "localhost", "test.bluewatersuite.net", "sawyer-staging-cart.web.app"].indexOf(location.hostname) > -1 && location.hash !== "#live" ? fbConfigStaging : fbConfig);
    if (location.hostname === "localhost") {
        // @ts-ignore
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    initializeAppCheck(fb, {
        provider: new ReCaptchaV3Provider("6LdEkSEqAAAAADS7u0lRH57Jt-tjHPkzg4bOEZ08"),
        isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
    });
    var firestore = getFirestore(fb);
    var auth = getAuth(fb);
    const storage = getStorage(fb);
    //fb.firestore().clearPersistence();
    // if (["test.bluewatersuite.net", "localhost"].includes(location.hostname) && location.hash !== "#live") {
    // const s = getStorage();
    // connectStorageEmulator(s, "localhost", 9199);
    // connectFirestoreEmulator(firestore,"localhost", 8080);
    //}
    const functions = getFunctions(fb);
    window.firebase = fb;
    window.firestore = firestore;
    window.functions = functions;
    window.auth_instance = auth;
    window.storage = storage;
    /* fb.firestore().enablePersistence()
    .catch(function(err: FirestoreError) {
      console.error(err);
      if (err.code === 'failed-precondition') {
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
      } else if (err.code === 'unimplemented') {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
      }
    }); */
    dispatch(firebaseAuthInitialize(fb, firestore));
    dispatch({
        type: FIREBASE_INITIALIZE,
        firebase: fb,
        firestore: firestore
    });
};
export const firebaseAuthInitialize = (fb) => (dispatch) => {
    if (fb) {
        var auth = getAuth(fb);
        if (["test.bluewatersuite.net", "localhost"].includes(location.hostname) && location.hash !== "#live") {
            // connectAuthEmulator(auth, 'http://localhost:9099');
        }
        setPersistence(auth, browserLocalPersistence);
        onAuthStateChanged(auth, (u) => {
            dispatch(firebaseAuthorize(u));
        });
    }
    dispatch({
        type: FIREBASE_AUTH_INITIALIZE
    });
};
export const firebaseAuthorize = (user) => (dispatch) => {
    if (user) {
        if (!user.isAnonymous) {
            const docRef = doc(window.firestore, "UserProfiles", user.uid);
            getDoc(docRef).then((userDoc) => {
                if (userDoc.exists() && userDoc.get("person")) {
                    //Get Company Doc for company settings & apps available
                    const personRef = userDoc.get("person");
                    onSnapshot(personRef, (personDoc) => {
                        if (personDoc.exists()) {
                            dispatch(personLoaded(personDoc));
                        }
                    });
                    dispatch(firebaseFirestore(userDoc));
                }
                else {
                    dispatch(firebaseSignOut());
                    return;
                }
                if (userDoc.exists() && userDoc.get("company")) {
                    //Get Company Doc for company settings & apps available
                    const companyRef = userDoc.get("company");
                    // if the user cannot get company doc because of security rules, logout and redirect to login
                    getDoc(companyRef).then(async (companyDoc) => {
                        if (!companyDoc.exists() || !companyDoc.get("active")) {
                            dispatch(firebaseSignOut());
                            return;
                        }
                        if (companyDoc.exists()) {
                            //get settings
                            const settings = await getDocs(collection(companyDoc.ref, "Settings"));
                            const settingsMap = new Map();
                            settings.docs.forEach((set) => {
                                settingsMap.set(set.id, set);
                            });
                            window.bws_settings = settingsMap;
                            dispatch(companyLoaded(companyDoc));
                            dispatch(firebaseFirestore(userDoc));
                            dispatch(loadOrganizations(companyDoc.ref));
                            if (window.location.pathname === '/login' || window.location.pathname === '/') {
                                dispatch(navigate('/home'));
                            }
                        }
                    }).catch((error) => {
                        console.error("Error getting company doc", error);
                        dispatch(firebaseSignOut());
                    });
                }
                else {
                    dispatch(firebaseSignOut());
                }
                if (userDoc.exists() && userDoc.get("vendor")) {
                    //Get Company Doc for company settings & apps available
                    const vendorRef = userDoc.get("vendor");
                    getDoc(vendorRef).then((vendorDoc) => {
                        if (vendorDoc.exists()) {
                            dispatch(vendorLoaded(vendorDoc));
                            if (window.location.pathname === '/login' || window.location.pathname === '/') {
                                dispatch(navigate('/home'));
                            }
                        }
                    });
                    dispatch(firebaseFirestore(userDoc));
                }
                if (!userDoc || !userDoc.exists() || (!userDoc.get("company") && !userDoc.get("vendor"))) {
                    dispatch(navigate('/login'));
                }
            });
        }
        else {
            dispatch(navigate('/login'));
        }
    }
    else {
        dispatch(navigate('/login'));
    }
    dispatch({
        type: FIREBASE_AUTHORIZE,
        user
    });
};
export const companyLoaded = (companyDoc) => {
    return {
        type: COMPANY_LOADED,
        companyDoc: companyDoc
    };
};
export const vendorLoaded = (vendorDoc) => {
    return {
        type: VENDOR_LOADED,
        vendorDoc
    };
};
export const personLoaded = (personDoc) => {
    if (window.location.pathname.indexOf("oauth") >= -1)
        personIntegrationReceived(window.location.pathname.split("/")[2], personDoc);
    return {
        type: PERSON_LOADED,
        personDoc
    };
};
export const personIntegrationReceived = (partnerId, personDoc) => {
    if (partnerId && personDoc) {
        partnerId = partnerId.toUpperCase();
        var integration = {};
        integration[partnerId] = {};
        const personDocRef = doc(window.firestore, "Integration", partnerId);
        getDoc(personDocRef)
            .then((partnerDoc) => {
            if (partnerDoc.exists()) {
                var partnerData = partnerDoc.data();
                const q = new URLSearchParams(window.location.search);
                integration[partnerId][partnerData.authCode] = q.get(partnerData.authCode);
                var tokenUrl = partnerData.baseUrl + partnerData.authToken;
                const formData = new URLSearchParams();
                Object.keys(partnerData.authTokenFields).forEach((f) => {
                    formData.append(f, partnerData.authTokenFields[f].replace("${" + f + "}", f === 'code' ? integration[partnerId][partnerData.authCode] : partnerData[f]));
                });
                fetch(tokenUrl, {
                    method: 'POST',
                    //headers: new Headers({"Authorization": `Basic ${partnerData.client_id}`}),
                    body: formData
                })
                    .then(response => { console.log(response); return response.json(); })
                    .then((respToken) => {
                    console.log(respToken);
                    integration[partnerId].accessToken = respToken;
                    return fetch(partnerData.baseUrl + partnerData.authCurrentUser, {
                        headers: {
                            "Accept": "application/vnd.plic.io.v2+json",
                            "Authorization": integration[partnerId].accessToken.token_type + ' ' + integration[partnerId].accessToken.access_token,
                        }
                    });
                })
                    .then(response => { console.log(response); return response.json(); })
                    .then((resp) => {
                    console.log(resp);
                    integration[partnerId].user = resp;
                    return updateDoc(personDoc.ref, { integration: integration });
                }).then(() => {
                    alert("UPDATED PERSON WITH INTEGRATION");
                    window.close();
                });
            }
        });
    }
    return {
        type: PERSON_LOADED,
        personDoc
    };
};
export const firebaseSignOut = () => {
    return {
        type: FIREBASE_SIGNOUT
    };
};
export const firebaseFirestore = (userDoc) => {
    return {
        type: FIREBASE_FIRESTORE,
        userDoc
    };
};
export const loadOrganizations = (companyRef) => {
    return {
        type: LOAD_ORGANIZATIONS,
        companyRef: companyRef
    };
};
export const loadJobs = (year) => {
    return {
        type: LOAD_JOBS,
        year: year
    };
};
export const loadJobTypes = () => {
    return {
        type: LOAD_JOBTYPES
    };
};
export const loadBackgroundSets = () => {
    return {
        type: LOAD_BACKGROUNDSETS
    };
};
export const organizationsLoaded = (organizations) => {
    return {
        type: ORGANIZATIONS_LOADED,
        organizations
    };
};
export const jobsLoaded = (jobs) => {
    return {
        type: JOBS_LOADED,
        jobs
    };
};
export const jobGet = (jobId) => {
    return {
        type: JOB_GET,
        jobId: jobId
    };
};
export const jobTypesLoaded = (jobTypes) => {
    return {
        type: JOBTYPES_LOADED,
        jobTypes
    };
};
export const backgroundSetsLoaded = (backgroundSets) => {
    return {
        type: BACKGROUNDSETS_LOADED,
        backgroundSets
    };
};
export const loadBackgrounds = (backgroundSetRef) => {
    return {
        type: LOAD_BACKGROUNDS,
        backgroundSetRef
    };
};
export const backgroundsLoaded = (backgrounds) => {
    return {
        type: BACKGROUNDS_LOADED,
        backgrounds
    };
};
